export default __webpack_public_path__ + "static/media/icone-manual.ce8766e2.svg";